export default function formatErrors (allErrors) {
  let errors = {}
  for (let i in allErrors) {
    if (allErrors.hasOwnProperty(i)) {
      errors[i] = allErrors[i][0]
    }
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/utils/formatErrors.js